import { mergeStyles } from '../../../internal/utils';
import * as inputWrapperStyles from '../../../internal/styles/inputWrapperAdornment.module.css';
import * as mainStyles from './styles.module.css';
export function getInputAdornmentStyles(size) {
  return mergeStyles(mainStyles, inputWrapperStyles, require("./size/".concat(size, ".module.css")));
}